export const comparisonOperators = {
  EQUAL: '=',
  GREATER: '>',
  GREATER_OR_EQUAL: '>=',
  LOWER: '<',
  LOWER_OR_EQUAL: '<='
}
